module.exports = __webpack_public_path__ + "img/Krzysztof Fila.050db94b.jpg";